import React from "react";
import Navbar from "../../components/navbar/Navbar";

const ResumeHelp = () => {
  return (
    <>
      <Navbar showLinks={true} />
      <div className="pages-container">
        <h1 className="pages-content">Resume/CV Help Coming Soon!</h1>
      </div>
    </>
  );
};

export default ResumeHelp;
